import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { PalmTreeIcon } from 'probonio-shared-ui/component/icon';
import React from 'react';
import { BenefitMetadataExtensionInterface } from '../../../../extension/interface/benefit-metadata.extension.interface';

export class RecreationBenefitMetadataExtension extends BenefitMetadataExtensionInterface {
  benefitId: BenefitDTOBenefitEnum = BenefitDTOBenefitEnum.Recreation;
  get Icon(): React.ComponentType<SvgIconProps> {
    return PalmTreeIcon;
  }
}
